module.exports = __webpack_public_path__ + "static/img/fenglun.df0d110.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/fenglun.png
// module id = 3arO
// module chunks = 0